import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { ScrollUtil } from '../../../../util/ScrollUtil';
import SessionStorageUtil from '../../../../util/SessionStorageUtil';
import { APPLE_PAY_PAYMENT_FAILED } from '../../../../constants/StorageKeysConstants';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
const APPLE_PAY_PAYMENT_ERROR_ID = 'applepaypaymenteprror-feedbackmessage';
export const ApplePayMessage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const [applePayPaymentError, setApplePayPaymentError] = useState(false);
    useEffect(() => {
        const applePayPaymentFailed = SessionStorageUtil.getJsonItem(APPLE_PAY_PAYMENT_FAILED);
        if (applePayPaymentFailed) {
            SessionStorageUtil.removeItem(APPLE_PAY_PAYMENT_FAILED);
            setApplePayPaymentError(applePayPaymentFailed);
        }
        else {
            setApplePayPaymentError(false);
        }
        EventUtil.listen(EventEnum.APPLE_PAY_PAYMENT_FAILED, () => {
            setApplePayPaymentError(true);
        });
    }, []);
    useEffect(() => {
        if (applePayPaymentError) {
            ScrollUtil.scrollToErrorElement(document.getElementById(APPLE_PAY_PAYMENT_ERROR_ID));
        }
    }, [applePayPaymentError]);
    if (!applePayPaymentError)
        return null;
    return (_jsx("div", { id: APPLE_PAY_PAYMENT_ERROR_ID, children: _jsx(Banner, { status: "error", text: t('buy.payment.applepay.error.generic') }) }));
};
